import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ModalContent, ModalHeader, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ModalSectionTitle, ModalTitle, ScrollableContent } from "../Styles/InputStyles";
import { capitalizeFirstLetter, getLandlordTransactionFor, getModeName } from "../../helpers";
import { Link } from "react-router-dom";
import ModalProfileHeader from "../Common/ModalProfileHeader";

const ViewTransDetails = ({
    setViewDetail,
    selectedData,
}) => {
    const onClose = () => {
        setViewDetail(false);
    };

    return (
        <>
            <Container>
                <ModalHeader>
                    <ModalTitle>Payment Details</ModalTitle>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>
                {/* <ProfileSection className="flex justify-between">
                    <UserInfo>
                        <span className="font-medium mb-0">
                            {capitalizeFirstLetter(selectedData?.landlordName || 0)}
                        </span>
                        <span className="text-sm text-gray-600">
                            {'#' + selectedData?.landlordMobile}
                        </span>
                    </UserInfo>
                    <div className="flex flex-col gap-0">
                        <span className='text-gray-500 text-sm'>{'Amount'}</span>
                        <span className='text-xl font-semibold text-gray-700'>{'₹' + selectedData?.amount}</span>
                    </div>
                </ProfileSection> */}

                <ModalProfileHeader
                    title="Due Details"
                    name={capitalizeFirstLetter(selectedData?.landlordName)}
                    subtitle={`#${selectedData?.landlordMobile}`}
                    amountLabel={"Amount"}
                    amount={selectedData?.amount}
                    image={selectedData?.profilePicture}
                    onClose={onClose}
                />

                <ModalContent>
                    <ScrollableContent>
                        <Wrapper>
                            <BtnWrapper>
                                <ModalSectionTitle>Payment Information</ModalSectionTitle>
                            </BtnWrapper>
                            <ModalSection>
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Payment Type</ModalRowLabel>
                                        <ModalRowValue>{getLandlordTransactionFor(selectedData)}</ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Paid By</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.paidByName ? selectedData?.paidByName : '--'}</ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Due Date</ModalRowLabel>
                                        <ModalRowValue>{moment(selectedData.dueDate).format("DD, MMM YY")}</ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Payment Date</ModalRowLabel>
                                        <ModalRowValue>{moment(selectedData.paidDate).format("DD, MMM YY: HH:mm")}</ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                                {selectedData?.flatName &&
                                    <ModalRow>
                                        <FlexCol>
                                            <ModalRowLabel>For Property</ModalRowLabel>
                                            <ModalRowValue>
                                                {selectedData?.propertyName || "-"}
                                            </ModalRowValue>
                                        </FlexCol>
                                        <FlexCol>
                                            <ModalRowLabel>For Flat</ModalRowLabel>
                                            <ModalRowValue>
                                                {selectedData?.flatName || "-"}
                                            </ModalRowValue>
                                        </FlexCol>
                                    </ModalRow>
                                }
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Payment Mode</ModalRowLabel>
                                        <ModalRowValue>{getModeName(selectedData?.paymentMethod)}</ModalRowValue>
                                    </FlexCol>
                                    {!selectedData?.flatName &&
                                        <FlexCol>
                                            <ModalRowLabel>For Property</ModalRowLabel>
                                            <ModalRowValue>
                                                {selectedData?.propertyName || "-"}
                                            </ModalRowValue>
                                        </FlexCol>
                                    }
                                </ModalRow>
                                <ModalRow >
                                    <FlexCol >
                                        <ModalRowLabel>UTR</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.bankRefNum ? selectedData?.bankRefNum : '--'}</ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                                <ModalRow className='grid-cols-1'>
                                    <FlexCol >
                                        <ModalRowLabel>Description</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.description || "--"}</ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                            </ModalSection>
                            {selectedData?.remarks &&
                                <>
                                    <BtnWrapper>
                                        <ModalSectionTitle>Remarks</ModalSectionTitle>
                                    </BtnWrapper>
                                    <Section>
                                        <ModalRowValue>{selectedData?.remarks || "--"}</ModalRowValue>
                                    </Section>
                                </>
                            }
                            <div className="flex justify-end">
                                <FlexCol>
                                    <ModalRowValue className="text-blue-500 underline">
                                        <Link
                                            to={selectedData?.supportDoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {selectedData?.supportDoc?.split("/").pop()}
                                        </Link>
                                    </ModalRowValue>
                                </FlexCol>
                            </div>
                        </Wrapper>
                    </ScrollableContent>
                </ModalContent>
            </Container >


        </>
    );
};

const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
//const ModalSectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
//const ModalRow = tw.div`grid grid-cols-2 py-1 md:p-1`;
//const ModalRowLabel = tw.label`text-sm text-gray-400 font-normal`;
//const ModalRowValue = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;

export default ViewTransDetails;